import React from 'react'

//components
import { BasicCheckbox } from 'thrive-components';
import PasskeyUsersPanel from  '@/components/elements/orgSettings/passkeys/PasskeyUsersPanel';

//interfaces
import { IPasskeySettings } from  '@/interfaces/passkeys';



const PasskeySettings = ({userCountInfo, setShowModal, passkeysEnabled, onEnablePasskeysClick, forcePasskeySignIn, setForcePasskeySignIn} : IPasskeySettings) => {  
    return(
        <>
            <PasskeyUsersPanel 
                {...userCountInfo}
                onViewUsersClick= {()=>setShowModal(true)}
            />
            
            <div className={`passkey-checkbox-wrapper enable-passkey-wrapper`}>
                <BasicCheckbox 
                    id={'enable-passkey-checkbox'} 
                    isChecked={passkeysEnabled} 
                    onChange={onEnablePasskeysClick} 
                    label={'Enable Passkey sign in'}     
                    ariaLabel={'Enable Passkey sign in'}        
                />
                <span className='passkey-checkbox-information'>
                    Allows users to sign in using Passkeys instead of passwords. Once enabled, users can add a Passkey after signing in.
                </span>
            </div>

            <div className={`passkey-checkbox-wrapper ${!passkeysEnabled ? "disabled-passkey-checkbox" : ""}`}>
                <BasicCheckbox 
                    id={'force-passkey-checkbox'} 
                    isChecked={forcePasskeySignIn} 
                    onChange={()=>setForcePasskeySignIn(!forcePasskeySignIn)} 
                    label={'Force Passkey setup'}    
                    isDisabled={!passkeysEnabled}     
                    ariaLabel='Force Passkey setup'       
                />
                <span className={`passkey-checkbox-information`}> 
                    After signing in with a password, users must set up a Passkey before they can continue using the app.
                </span>
            </div>
        </>
    )
}

export default PasskeySettings